import {
  Button as AntdButton,
  ButtonProps as AntdButtonProps,
  Tooltip,
} from "@basic-components";

import { useUserPermission } from "@/hooks/userPermission";

const NO_PERMISSION_TIP = "暂无权限";

const Button = ({
  authKey,
  children,
  noPermissionTip = NO_PERMISSION_TIP,
  ...restProps
}: {
  authKey?: string;
  children?: React.ReactNode;
  noPermissionTip?: string;
} & AntdButtonProps) => {
  const hasPermission = useUserPermission(authKey);

  if (!hasPermission) {
    // 无权限时不隐藏，改为置灰禁用 + 鼠标悬停提示。
    // 包一层 span：antd 禁用按钮的 pointer-events 为 none，
    // 直接挂 Tooltip 无法在 hover 时触发，需由外层元素接收鼠标事件。
    return (
      <Tooltip title={noPermissionTip}>
        <span style={{ cursor: "not-allowed", display: "inline-block" }}>
          <AntdButton
            {...restProps}
            disabled
            onClick={undefined}
            style={{ pointerEvents: "none", ...restProps.style }}
          >
            {children}
          </AntdButton>
        </span>
      </Tooltip>
    );
  }
  return <AntdButton {...restProps}>{children}</AntdButton>;
};

export const AuthButton = ({
  authKey,
  children,
  noPermissionTip,
  ...restProps
}: {
  authKey?: string;
  children?: React.ReactNode;
  noPermissionTip?: string;
} & AntdButtonProps) => {
  if (!authKey) {
    return <AntdButton {...restProps}>{children}</AntdButton>;
  }
  return (
    <Button authKey={authKey} noPermissionTip={noPermissionTip} {...restProps}>
      {children}
    </Button>
  );
};
